import useGetCurrentEntity from 'hooks/useGetCurrentEntity';

const useCurrentEntityUsesPoints = () => {
    const currentEntity = useGetCurrentEntity();
    return currentEntity?.usesPoints ?? true;
};

export default useCurrentEntityUsesPoints;
